import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';


// material
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTabsModule} from "@angular/material/tabs";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatChipsModule} from "@angular/material/chips";
import {MatCardModule} from "@angular/material/card";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {MatMenuModule} from "@angular/material/menu";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatDialogModule} from "@angular/material/dialog";
import {MatSliderModule} from "@angular/material/slider";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';

// font awesome
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faBan,
  faBars,
  faBomb,
  faBook,
  faCalendar,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCheck,
  faClone,
  faCog,
  faCopy,
  faDollarSign,
  faEdit,
  faEnvelopeOpen,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileExport,
  faFileImport,
  faFileInvoiceDollar,
  faFileSignature,
  faFilter,
  faLanguage,
  faLightbulb,
  faMap,
  faPaintBrush,
  faPaperclip,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faMinus,
  faMinusCircle,
  faPowerOff,
  faRocket,
  faSearch,
  faSave,
  faSeedling,
  faSquare,
  faStream,
  faTasks,
  faTimes,
  faTrash,
  faUnlink,
  faUser,
  faUserCircle,
  faUserPlus,
  faWindowMaximize,
  faFileAlt,
  faLocationArrow,
  faSearchLocation,
  faMapPin,
  faCalendarCheck,
  faCalendarWeek,
  faClipboardList,
  faEllipsisV,
  faFileUpload,
  faFileDownload,
  faBackward,
  faStepBackward,
  faCaretLeft,
  faMailBulk,
  faInfoCircle,
  faTimesCircle,
  faCloudUploadAlt,
  faReply,
  faFileContract,
  faComment,
  faCheckCircle,
  faCircle,
  faCarSide,
  faRetweet,
} from '@fortawesome/free-solid-svg-icons';

// base components
import {
  AddButtonComponent,
  ConfirmDialogComponent,
  CRUDButtonsComponent,
  DetailComponent,
  TableComponent
} from './components';
import { BaseComponent } from './components/base';
import { TableItemsComponent } from './components/table-items/table-items.component';
import {MzdTimelineModule} from "ngx-mzd-timeline";

const matModules = [
  MatButtonModule,
  MatCheckboxModule,
  MatDividerModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
  MatRadioModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatTooltipModule,
  MatToolbarModule,
  MatTabsModule,
  MatProgressSpinnerModule,
  MatChipsModule,
  MatCardModule,
  MatSidenavModule,
  MatListModule,
  MatMenuModule,
  MatSnackBarModule,
  MatSlideToggleModule,
  MatDialogModule,
  MatSliderModule,
  MatDatepickerModule,
  MatAutocompleteModule,
  MatNativeDateModule
];

const customComponents = [
  DetailComponent,
  TableComponent,
  ConfirmDialogComponent,

  CRUDButtonsComponent,
  AddButtonComponent,
  TableItemsComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ...customComponents,
    BaseComponent,
    TableItemsComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    HttpClientJsonpModule,
    HttpClientModule,
    MzdTimelineModule,
    ...matModules
  ],
  exports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    HttpClientModule,
    ...matModules,
    ...customComponents,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'}
  ],
})
export class SharedModule {
  constructor(faIconLibrary: FaIconLibrary) {
    faIconLibrary.addIcons(
      faFileSignature,
      faFileInvoiceDollar,
      faMap,
      faSearch,
      faTrash,
      faBars,
      faUserCircle,
      faPowerOff,
      faCog,
      faRocket,
      faPlayCircle,
      faPlus,
      faPlusCircle,
      faMinus,
      faMinusCircle,
      faEdit,
      faTrash,
      faTimes,
      faCaretUp,
      faCaretDown,
      faExclamationTriangle,
      faFilter,
      faTasks,
      faCheck,
      faSquare,
      faLanguage,
      faPaintBrush,
      faLightbulb,
      faWindowMaximize,
      faStream,
      faSave,
      faBook,
      faFileImport,
      faFileExport,
      faEye,
      faEyeSlash,
      faBan,
      faBomb,
      faDollarSign,
      faClone,
      faCopy,
      faFile,
      faCaretRight,
      faSeedling,
      faCalendar,
      faExclamationCircle,
      faExternalLinkAlt,
      faExchangeAlt,
      faUserPlus,
      faUnlink,
      faUser,
      faEnvelopeOpen,
      faPaperclip,
      faFileAlt,
      faLocationArrow,
      faSearchLocation,
      faMapPin,
      faCalendarCheck,
      faCalendarWeek,
      faClipboardList,
      faEllipsisV,
      faFileUpload,
      faFileDownload,
      faBackward,
      faStepBackward,
      faCaretLeft,
      faMailBulk,
      faInfoCircle,
      faTimesCircle,
      faCloudUploadAlt,
      faReply,
      faFileContract,
      faComment,
      faCheckCircle,
      faCircle,
      faCarSide,
      faRetweet,
    );
  }
}
